export const INLINE_VARIANT = 'inline';
export const CURSOR_VARIANT = 'cursor';

export const TOP_POSITION = 'top';
export const BOTTOM_POSITION = 'bottom';
export const START_POSITION = 'start';
export const END_POSITION = 'end';

export const TRIGGER_AUTO = 'auto';
export const TRIGGER_ROUND = 'round';
export const TRIGGER_BUTTON = 'button';
export const TRIGGER_ICON = 'icon';
export const TRIGGER_TEXT = 'text';
